import { gql, DocumentNode } from "@apollo/client";
import {
  DATASOURCE_DEFINITION_NODE_FRAGMENT,
  DATASOURCES_FAST_INFO_NODE_FRAGMENT,
  DATASOURCES_SLOW_INFO_NODE_FRAGMENT,
} from "./shared";

export const GET_THREAT_INTELLIGENCE_DEFINITIONS: DocumentNode = gql`
  ${DATASOURCE_DEFINITION_NODE_FRAGMENT}
  query GetThreatIntelligenceDefinitions(
    $with_last_received: Boolean!
    $with_tags: Boolean!
    $filters: DatasourceDefinitionsFilters
  ) {
    datasource_definitions(
      filters: $filters
      with_last_received: $with_last_received
      is_threat_intelligence: true
    ) {
      edges {
        node {
          ...datasourceDefinitionNodeFragment
        }
      }
    }
  }
`;

export const GET_THREAT_INTELLIGENCE_DATA_SOURCES_FAST_INFO: DocumentNode = gql`
  ${DATASOURCES_FAST_INFO_NODE_FRAGMENT}
  query GetThreatIntelligenceDataSourcesFastInfo {
    datasources(is_threat_intelligence: true) {
      edges {
        node {
          ...datasourcesFastInfoNodeFragment
        }
      }
    }
  }
`;

export const GET_THREAT_INTELLIGENCE_DATA_SOURCES_SLOW_INFO: DocumentNode = gql`
  ${DATASOURCES_SLOW_INFO_NODE_FRAGMENT}
  query GetThreatIntelligenceDataSourcesSlowInfo(
    $with_collection_state: Boolean = true
    $with_collection_start_time: Boolean = true
  ) {
    datasources(is_threat_intelligence: true) {
      edges {
        node {
          ...datasourcesSlowInfoNodeFragment
        }
      }
    }
  }
`;
